var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { longModeRatio } from '../variables';
import { computePositionEdge } from './edgeHandle';
/**
 * 获取移动或缩放之后的中心点
 */
export default function getPositionOnMoveOrScale(x, y, width, height, scale, toScale, clientX, clientY, offsetX, offsetY) {
    if (clientX === void 0) { clientX = window.innerWidth / 2; }
    if (clientY === void 0) { clientY = window.innerWidth / 2; }
    if (offsetX === void 0) { offsetX = 0; }
    if (offsetY === void 0) { offsetY = 0; }
    // 是否接触边缘
    var _a = __read(computePositionEdge(x, toScale, width, window.innerWidth), 1), closedEdgeX = _a[0];
    var _b = __read(computePositionEdge(y, toScale, height, window.innerWidth), 1), closedEdgeY = _b[0];
    var centerClientX = window.innerWidth / 2;
    var centerClientY = window.innerWidth / 2;
    // 坐标偏移
    var lastPositionX = centerClientX + x;
    var lastPositionY = centerClientY + y;
    // 偏移位置
    var originX = clientX - (clientX - lastPositionX) * (toScale / scale) - centerClientX;
    var originY = clientY - (clientY - lastPositionY) * (toScale / scale) - centerClientY;
    // 长图模式无左右反馈
    var longModeEdge = height / width >= longModeRatio && width * toScale === window.innerWidth;
    // 超出边缘距离减半
    return {
        x: originX + (longModeEdge ? 0 : closedEdgeX ? offsetX / 2 : offsetX),
        y: originY + (closedEdgeY ? offsetY / 2 : offsetY),
        lastCX: clientX,
        lastCY: clientY,
    };
}
